import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { AuthService } from '../../providers/auth/auth';

import { FirebaseDatabase } from 'angularfire2';
import { AngularFireDatabase } from 'angularfire2/database';

/**
 * Generated class for the RoulettePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-roulette',
  templateUrl: 'roulette.html',
})
export class RoulettePage {

  userToSend: any;
  dateLaunch: string;
  dateError: boolean;
  dateLunch: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public auth: AuthService, private fbDB: AngularFireDatabase, public toastCtrl: ToastController, public loadingCtrl: LoadingController) {
    this.dateLaunch = null;
    this.dateError = false;
  }

  logout() {
    this.auth.logout();
  }

  random() {
    if (this.dateLaunch != null && this.dateLaunch.length > 3) {
      let loading = this.loadingCtrl.create();
      loading.present();

      this.auth.getUserData().then((user) => {

        this.fbDB.database.ref("users").once("value", (snapshot) => {
          let users = snapshot.val();

          let arr = [];
          for (let key in users) {
            if (users.hasOwnProperty(key)) {
              if (users[key].email != user.email) {
                arr.push(users[key]);
              }
            }
          }

          let length = arr.length;
          let random = Math.floor((Math.random() * length));
          this.userToSend = arr[random];

          let entryObject = {
            fromName: user.name,
            fromCompany: user.company,
            fromEmail: user.email,
            toName: this.userToSend.name,
            toEmail: this.userToSend.email,
            toCompany: this.userToSend.company,
            dateLaunch: this.dateLaunch
          }

          this.fbDB.database.ref("submits").push(entryObject).then(() => {
            loading.dismiss();

            let toast = this.toastCtrl.create({
              message: this.userToSend.name + " hat eine Einladung zum Mittagessen von dir bekommen.",
              duration: 3000,
              position: 'top'
            });
            toast.present();
          });
        });
      });
    } else {
      let toast = this.toastCtrl.create({
        message: "Bitte trage ein Datum ein.",
        duration: 3000,
        position: 'top'
      });
      toast.present();
      this.dateError = true;
      setTimeout(() => {
        this.dateError = false;
      }, 3000);
    }
  }

  test() {
    let tokens = this.dateLunch.split("-");
    this.dateLaunch = tokens[2] + "." + tokens[1] + "." + tokens[0];
  }
}



// WEBPACK FOOTER //
// ./src/pages/roulette/roulette.ts